import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import { useEventDefs } from "@/api/useEventDefs";
import FreshpaintUser from "@/components/users/FreshpaintUser";
import useAccountMetadata from "@/hooks/useAccountMetadata";
import useFeatureFlags from "@/hooks/useFeatureFlag";
import { FreshpaintState } from "@/reducers";

function EntryPage() {
  const { data: events = [], isLoading: eventsLoading } = useEventDefs();
  const accountMetadata = useAccountMetadata();
  const flag = useFeatureFlags();
  const currentUser = useSelector((s: FreshpaintState) => s.users.currentUser);

  if (eventsLoading || !accountMetadata.loaded) {
    return null;
  }

  if (
    flag("accountDashboard") &&
    new FreshpaintUser(currentUser).hasAdminAccess()
  ) {
    return <Redirect to={{ pathname: "/account-dashboard" }} />;
  }

  if (events.length === 0) {
    return <Redirect to={{ pathname: "/events/library" }} />;
  }

  if (!flag("insightsOptOut")) {
    return <Redirect to={{ pathname: "/insights" }} />;
  }

  return <Redirect to={{ pathname: "/events/library" }} />;
}

export default EntryPage;
